import React, {Component} from 'react';
import {connect} from 'react-redux';
import { API_URL } from '../../config/apiEndpoints';
import Moment from 'react-moment';
import 'moment/locale/ro';
import Favorite from '../favorite/favorite.component';
import { Link } from 'react-router-dom';
import { slugify } from '../../helpers/general.helper';
import { addFestivalToFavorite, removeFestivalFromFavorite } from '../../actions/festival.actions'; 
import Parser from 'html-react-parser';


class CarouselItemFestival extends Component {

    render() {
        return (
            <div className="carousel-festival">
                <div className="col-12 image-holder">
                    <Link to={`festival/${this.props.card.festival_id}/${slugify(this.props.card.festival_title)}`} >
                        <img alt={'Festival'} src={ API_URL + Parser(this.props.card.festival_image) } />
                    </Link>
                </div>
                <div className="col-12 period">
                    <span className="festival-period-carousel">
                        <Moment format="DD MMMM" locale="ro" unix>
                            { this.props.card.festival_period_start }
                        </Moment>
                        {" - "}
                        <Moment format="DD MMMM YYYY" locale="ro" unix>
                            { this.props.card.festival_period_end }
                        </Moment>
                    </span>
                </div>
                <div className="col-12 title-holder"> 
                    <Favorite 
                        favorite={this.props.card.favorite} 
                        component="carousel" 
                        type="festival"
                        id={this.props.card.festival_uuid}
                    />   
                    <div className="festival-title">
                        <span className="title-item">
                            <Link to={`festival/${this.props.card.festival_id}/${slugify(this.props.card.festival_title)}`} className="white-text">
                                {this.props.card.festival_title}
                            </Link>
                        </span> 
                    </div>  
                </div>
                <div className="col-12 festival-subtitle-holder">
                    <span className="festival-subtitle-item">
                       {this.props.card.festival_subtitle}
                    </span>
                </div>
                <div className="col-12 festival-where">
                    <span className="festival-where-item-left">
                        Unde:
                        </span>
                    <span className="festival-where-item-right">
                        {' ' + this.props.card.festival_location}
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {addFestivalToFavorite, removeFestivalFromFavorite})(CarouselItemFestival);


// WEBPACK FOOTER //
// ./src/SHARED/components/carousel/carouselitemfestival.component.js